/**
 * Function: setModals() - appends a modal at the body's level for each image
 * in trucks' photo galleries.
 * Usage: it is intended to be used in truck photo galleries. Once the image
 * of the slider is clicked, a modal with that same image (larger version),
 * will pop up.
 */

const setModals = (modalsArr) => {

  const getModal = (content, modId) => {
    let modal = `
    <div class="modal fade truck-img-modal" id="imgModal-${modId}" tabindex="-1" aria-labelledby="imgModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-body">
            ${content}
          </div><!--.modal-body-->
        </div><!--.modal-content-->
      </div><!--.modal-dialog-->
    </div><!--.modal-->`;

    return modal;
  };

  const setModal = (modal) => {
    document.body.insertAdjacentHTML('beforeend', modal);
    return true;
  }

  modalsArr.map((mod) => {
    const content = mod.innerHTML;
    const modId = mod.attributes['data-modal-id'].value;
    const modal = getModal(content, modId);

    setModal(modal);
  });
}

document.addEventListener('DOMContentLoaded', (e) => {
  if (document.querySelectorAll('.is-modal-source')) setModals(Array.from(document.querySelectorAll('.is-modal-source')));
});